import { Injectable, Inject } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from '@snack-dev/angular-l10n';
import { environment } from '../../../environments/environment';
import { l10nLocales } from '../../localization.module';

@Injectable({
  providedIn: 'root'
})
export class LocaleService {

  constructor(@Inject(L10N_LOCALE) private l10nLocale: L10nLocale){
  }

  get locale(): L10nLocale {
    return this.l10nLocale;
  }

  get lang(): string {
    return this.l10nLocale.language;
  }

  private localesValue: string[] = null;
  get locales(): string[] {
    if (!this.localesValue) {
      this.localesValue = l10nLocales.map(l => l.locale);
    }
    return this.localesValue;
  }

  /**
   * Returns the translated help home slug.
   * @param lang By default the function uses the current language, this can be overriden with this param.
   * @returns The help slug for the current language.
   */
  getHelpSlug(lang: string = null) {
    if (!lang) {
      lang = this.lang;
    }
    if (lang === 'de') {
      return 'hilfe';
    } else if (lang === 'es'){
      return 'ayuda';
    } else if (lang === 'pt-br') {
      return 'ajuda';
    }
    return 'help';
  }

  /**
   * Returns the path prefix for the current language with slashes on start and end. en -> /, es -> /es/
   */
  getLangPathAbsolute() {
    return this.lang === 'en' ? '/' : '/' + this.lang + '/';
  }

  /**
   * Returns the site URL and base path depending on the current language.
   */
  getSiteUrl() {
    if (this.lang === 'en') {
      return 'https://www.hooksounds.com/';
    } else {
      return 'https://www.hooksounds.com/' + this.lang + '/';
    }
  }

  /**
   * Prepends the current language to the supplied path.
   */
  getLangLink(path: string) {
    if (!path.startsWith('/')) {
      path = '/' + path;
    }
    if (!path.endsWith('/')) {
      path = path + '/';
    }
    if (this.lang !== 'en') {
      path = '/' + this.lang + path;
    }
    return path;
  }

  /**
   * Prepends the current language and domain to the supplied path.
   */
  getLangFullLink(path: string) {
    let langPath = this.getLangLink(path);
    if (langPath.startsWith('/')) {
      langPath = langPath.substr(1);
    }
    return environment.url + langPath;
  }

  /* Returns the Paddle languages*/

  getLangPaddle() {
    if (this.lang === 'pt-br') {
      return 'pt';
    }
    return this.lang;
  }

}
